import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-heading mb-4">
                <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
                  caoliushequ
                </Link>
              </h4>
              <p className="text-sm text-background-300 leading-relaxed">
                caoliushequ官方入口导航站，提供最新可用地址、访问教程及常见问题解答，帮助用户快速找到caoliushequ官方入口。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">快速导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/latest-address" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">最新地址</Link>
                <Link to="/category/access-guide" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">访问教程</Link>
                <Link to="/category/community-news" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">社区动态</Link>
                <Link to="/category/faq" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">用户口碑</Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">免责声明</h4>
              <p className="text-sm text-background-300 leading-relaxed">
                本导航站为caoliushequ官方认证的信息发布平台，仅供用户获取最新访问地址及相关指南。请用户遵守当地法律法规，合理使用社区服务。
              </p>
            </div>
          </div>

          <div className="border-t border-background-300/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-sm text-background-400">
              &copy; {new Date().getFullYear()} caoliushequ 官方导航站 · 保留所有权利
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}